module.exports = {"340506100":"博望镇","340506101":"丹阳镇","340506102":"新市镇","340506400":"博望高新技术产业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340506.json
// module id = 988
// module chunks = 0